import { Phone, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-midnight text-ivory py-20">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-12">
        <div>
          <img src="/assets/fantasy-logo.webp" alt="Fantasy Dancefloors" data-testid="footer-logo" className="h-24 sm:h-28 w-auto mb-6" />
          <p className="text-ivory/50 font-light text-sm max-w-xs leading-relaxed">
            Where your biggest centerpiece becomes an unforgettable dream come true.
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <a href="tel:9784065564" data-testid="footer-phone-link" className="flex items-center gap-3 text-ivory/80 hover:text-blush transition-colors duration-300">
            <Phone size={15} strokeWidth={1.5} />
            <span className="font-serif text-2xl">978-406-5564</span>
          </a>
          <a href="mailto:dreams@fantasydancefloors.com" data-testid="footer-email-link" className="flex items-center gap-3 text-ivory/80 hover:text-blush transition-colors duration-300">
            <Mail size={15} strokeWidth={1.5} />
            <span className="font-serif text-lg sm:text-2xl break-all">dreams@fantasydancefloors.com</span>
          </a>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 mt-16 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-[11px] tracking-[0.3em] uppercase text-ivory/35">© 2026 Fantasy Dancefloors</p>
        <a href="mailto:ceoformulas@gmail.com" data-testid="footer-credit-link" className="text-[11px] tracking-[0.3em] uppercase text-ivory/35 hover:text-blush transition-colors duration-300">Crafted with love & a thousand tiny lights</a>
      </div>
    </footer>
  );
}
